module.exports = __webpack_public_path__ + "images/building@2x.3840861a2bb026d48a394dc4cb942c68.jpg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/building@2x.jpg
// module id = 983
// module chunks = 0